import styled from 'styled-components';

export const StyledFarmUserListPage = styled.div`
  .user-roles {
    width: 220px;
  }

  .actions {
    width: 125px;
  }

  .action-type {
    width: 125px;
  }

  .status-actions {
    top: 65px !important;
  }

  .ant-table-content,
  .ant-table-body {
    overflow: visible !important;
  }
`;
